import api from "api";
import { DownloadConfig } from "./types"

export async function downloadResource(url: string, config: DownloadConfig) {
  const fileType = config?.type === "Report" ? ".pdf" : config?.type;

  try {
    const { data } = await api.get(config?.link, {
      responseType: "blob"
    });
    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", `${config?.name}${fileType}`);
    document.body.appendChild(link);
    link.click();
    setTimeout(function() {
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);
  } catch (err) {
    throw err;
  }
}
